import { Avatar, Box, Button, ButtonBase, Typography, useMediaQuery } from '@mui/material';
import { POST_BY_IDS_API, POST_DETAIL_API, USER_QUEST_API } from '../../api/endpoint';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import explore_more from '../../assets/ExploreNow.png';
import comment from '../../assets/comment.png';
import counterInstance from '../../api/counterConfig';
import createAxiosInstance from '../../api/axiosConfig';
import like from '../../assets/like.png';
import style from './style.module.css';
import view from '../../assets/view.png';

const UserQuest: React.FC = () => {
  const location = useLocation();
  const { handle } = useParams();
  const { userDetail, userId } = location.state || {};
  const [userContestWorkData, setUserContestWorkData] = useState<any>([]);
  const [pageKey, setPageKey] = useState<string | null>('');
  const [moreData, setMoreData] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const fetchUserQuesttWorks = async () => {
    try {
      if (pageKey === null) {
        return;
      }

      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${USER_QUEST_API}${userId}&page=${pageKey}&count=9`);

      if (response.data?.page) {
        setPageKey(response.data.page);
      } else {
        setPageKey(null);
      }

      const postIds = response.data?.data
        ?.map((item: any) => item.work_id || item.work_ids?.[0])
        .filter(Boolean)
        .join(',');

      if (!postIds) {
        console.warn('No valid post IDs found.');
        return;
      }

      const worksResponse = await axiosInstance.get(`${POST_BY_IDS_API}${postIds}`);

      const reorderedPostData = response.data.data
        .map((item: any) =>
          worksResponse.data?.data?.find((work: any) => work.post_id === (item.work_id || item.work_ids?.[0]))
        )
        .filter(Boolean);

      const counterResponses = await Promise.all(
        reorderedPostData.map(async (item: any) => {
          try {
            return await counterInstance.get(`${POST_DETAIL_API}/${userId}/${item.post_id}`);
          } catch (counterError) {
            console.error('Error fetching counter data for post:', item.post_id, counterError);
            return null;
          }
        })
      );

      const mergedData = reorderedPostData.map((post: any, index: any) => {
        const counterData = counterResponses[index]?.data?.Item || {};
        return {
          ...post,
          counter: {
            likes: counterData.likes?.N || '0',
            views: counterData.views?.N || '0',
            comments: counterData.comments?.N || '0',
            badge: counterData.badge?.S || '',
            user_orientation: counterData.user_orientation?.S || '',
            version: counterData.version?.N || '0',
            updated_at: counterData.updated_at?.S || '',
            active: counterData.active?.N || '0',
            added_by: counterData.added_by?.S || '',
            type: counterData.type?.S || '',
            cws: counterData.cws?.N || '0'
          }
        };
      });

      if (response.data?.data) {
        setUserContestWorkData((prevUserData: any) => [...prevUserData, ...mergedData]);
      }
    } catch (error) {
      console.error('Error fetching user quest works:', error);
    } finally {
      setMoreData(false);
    }
  };

  const handleMore = () => {
    setMoreData(true);
  };

  useEffect(() => {
    if (userId) {
      fetchUserQuesttWorks();
    }
  }, [moreData]);

  return (
    <div>
      <Typography
        style={{
          textAlign: 'center',

          color: 'white',
          fontWeight: 800,
          letterSpacing: isMobile ? 4 : 8,
          marginBottom: 7,
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '20px' : '48px'
        }}>
        {`${handle?.toUpperCase()}'s QUESTS WORKS`}
      </Typography>

      <div className={style['grid-container']}>
        {userContestWorkData && userContestWorkData.length > 0 ? (
          userContestWorkData.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className={style['grid-item']}
                style={{ height: isMobile ? '352px' : '400px', width: isMobile ? '340px' : '380px' }}>
                <div className={style['post-img']}>
                  <img
                    alt="quest-post"
                    src={`${process.env.REACT_APP_DEFAULT_AVATAR}/${item?.user_id}/WORKS/IMAGES/medium/${item?.files[0]?.name}`}></img>
                  <div>
                    <div className={style['avatar-container']}>
                      <Typography
                        sx={{
                          color: 'white',
                          fontFamily: 'Baloo2',
                          fontSize: '18px',
                          fontWeight: 500,
                          padding: '10px 10px 3px 10px'
                        }}>
                        {item.text}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'white',
                          fontFamily: 'Baloo2',
                          padding: '2px 10px 10px 10px',
                          fontSize: '22px',
                          fontWeight: 800
                        }}>
                        {`Score ${item.counter.cws}`}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className={style['reactions']}>
                  <div className={style['blurrr']}>
                    <div className={style['actions']}>
                      <img src={view} alt={'view'} />
                      <Typography style={{ padding: '10px' }}>{item.counter.views}</Typography>
                    </div>
                    <div className={style['actions']}>
                      <img src={like} alt={'like'}></img>
                      <Typography style={{ padding: '10px' }}>{item.counter.likes}</Typography>
                    </div>
                    <div className={style['actions']}>
                      <img src={comment} alt={'comment'}></img>
                      <Typography style={{ padding: '10px' }}>{item.counter.comments}</Typography>
                    </div>
                  </div>

                  <img
                    alt={'quest-post'}
                    src={`${process.env.REACT_APP_DEFAULT_AVATAR}/${item?.user_id}/WORKS/IMAGES/medium/${item?.files[0]?.name}`}></img>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ padding: isMobile ? '' : '0 0 10% 0' }}>
            <Typography style={{ fontFamily: 'Baloo2', color: 'white' }}>
              You haven&apos;t participated any quest yet!
            </Typography>
          </div>
        )}
      </div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: isMobile ? 2 : 10
        }}>
        {userContestWorkData && userContestWorkData.length > 0 && pageKey !== null && (
          <ButtonBase
            onClick={() => handleMore()}
            sx={{
              width: isMobile ? '20vw' : '15vw',
              height: '8vh'
            }}>
            <img src={explore_more} alt="Explore More" style={{ width: isMobile ? '30vw' : '20vw', height: 'auto' }} />
          </ButtonBase>
        )}
      </Box>
    </div>
  );
};
export default UserQuest;
